import { useEffect, useState } from "react";
import { Spinner } from "../components/common/Spinner"
import { SpinnerContainer } from "../components/common/SpinnerContainer"
import { TabButton } from "../components/profile/TabButton"
import TabContent from "../components/profile/TabContent";
import logo from '../assets/images/Rentic_logo.svg';
import { Input } from "../components/form/Input";
import { Label } from "../components/form/Label";
import Switch from "@mui/material/Switch";
import { UserRentalsList } from "./UserRentalsList";
import { UserBadge } from "../components/common/UserBadge";
import { ChatListCard } from "../components/chat/ChatListCard";
import ChatTabContent from "../components/chat/ChatTabContent";
import { Any } from "@react-spring/web";
import { ChatView } from "./ChatView";
import { NewChannelMessageFromSocket, UserChannelElementListResponse } from "../api/requests/interfaces/Channel";
import { getUserChannels } from "../api/requests/messages";
import { useAppSelector } from "../store/hooks";
import { DisplayType } from "../store/features/displaySlice";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import AnnouncementIcon from '@mui/icons-material/Announcement';
import { NoneUserRented } from "./NoneUserRentedPage";
import { ChatListCardSkeleton } from "../components/skeletons/ChatListCardSkeleton";
import { ChatRequestView, ChatRequestViewProps } from "../components/chat/ChatRequestView";
import { ProductListResponse } from "../api/requests/interfaces/Product";
import { Helmet } from "react-helmet-async";
import { SecondaryButton } from "../components/buttons/SecondaryButton";
import { InboxNewNotificationModel, InboxNotificationModel, InboxNotificationType } from "../store/features/inboxSlice";

export interface ChatsPageProps {
    pageType: string; // Rentals or rented page
}

export const ChatsPage: React.FC<ChatsPageProps> = (props) => {

    const [chatSelection, setChatSelection] = useState<number>(0);
    const [selectedChatId, setSelectedChatId] = useState<number | undefined>(undefined);
    const [channels, setChannels] = useState<UserChannelElementListResponse[]>([]);
    const [loadingChannels, setLoadingChannels] = useState<boolean>(true);
    const [totalChannelsAmount, setTotalChannelsAmount] = useState<number>(0);
    const newNotification = useAppSelector((state) => state.inbox.incomingNotification);

    const [mobileChatsView, setMobileChatsView] = useState<boolean>(true);
    const [isCreateNew, setIsCreateNew] = useState<boolean>(false);

    const user = useAppSelector(state => state.auth.user);

    const [searchParams, setSearchParams] = useSearchParams();
    const params = useParams();

    const location = useLocation();
    const data2: ChatRequestViewProps = location?.state || undefined;

    useEffect(() => {
        fetchUserChannels(2);
    }, [location.pathname, searchParams.get("new")])

    useEffect(() => {
        if (!searchParams.get('new') && !searchParams.get('selectedChatId') && channels.length) {
            const newChatId = channels[0].chat.id;
            setSearchParams({ ['selectedChatId']: newChatId.toString() })
            setSelectedChatId(newChatId);
        }
    }, [channels])

    useEffect(() => {
        if (newNotification) {
            handleUpdateIncomingChatNotification(newNotification);
        }
    }, [newNotification])

    useEffect(() => {
        if (searchParams.get('new')?.length) {
            setIsCreateNew(true)
        } else {
            setIsCreateNew(false)
            if (searchParams.get('selectedChatId')) {
                const newChatId = Number(searchParams.get('selectedChatId'));
                const foundChat = channels.find((ch) => ch.chat.id === newChatId);
                if (newChatId != selectedChatId && foundChat) {
                    handleChatSelect(newChatId);
                } else {
                    // searchParams.delete('selectedChatId');
                }
            } else {
                setMobileChatsView(true);
            }
        }
    }, [searchParams, channels])

    const fetchUserChannels = async (queryAmount: number) => {

        setChannels([]);
        setLoadingChannels(true);
        const res = await getUserChannels(0, 3, props.pageType === "rentals");
        setTotalChannelsAmount(res.total);
        console.log("channels: " + res.data);

        // Check if channel already exists in state
        /* setChannels((prevChannels) => {
            const newChannels = res.data.filter(newChannel =>
                !prevChannels.some(existingChannel => existingChannel.chat.id === newChannel.chat.id)
            );
            return [...prevChannels, ...newChannels];
        }); */
        setChannels(res.data);

        console.log("total: " + res.total);
        console.log("queryAmount: " + queryAmount);

        setLoadingChannels(false);
    }

    const handleUpdateIncomingChatNotification = (notif: InboxNotificationModel) => {
        if (notif.type === InboxNotificationType.NEW_MESSAGE && selectedChatId !== notif.chatChannelId) {
            // find if there is channel with this id that message was received for and update this channel as new message received
            let copiedMessageChannels = [...channels];
            const newMessageChannel = copiedMessageChannels.find((itm) => itm.chat.id === notif.chatChannelId);
            if (newMessageChannel) {
                newMessageChannel.chat.newMessage = true;
            }
            setChannels([...copiedMessageChannels]);
        }
    }

    // in chat list card update the last sent message for the currently opened chat
    const handleCurrentChatNewMessage = (msg: NewChannelMessageFromSocket) => {
        // find the current channel and update last message data
        let copiedMessageChannels = [...channels];
        const newMessageChannel = copiedMessageChannels.find((itm) => itm.chat.id === selectedChatId);
        if (newMessageChannel) {
            newMessageChannel.chat.lastMessageId = msg.lastMessageId;
            newMessageChannel.chat.lastMessageAtDate = msg.lastMessageAtDate;
            newMessageChannel.chat.lastMessageUserId = msg.lastMessageUserId;
            newMessageChannel.chat.lastMessageMessage = msg.lastMessageMessage;
            newMessageChannel.chat.lastMessageDocumentId = msg.lastMessageDocumentId;
            newMessageChannel.chat.lastMessageSeen = true;
            newMessageChannel.chat.newMessage = false
        }
        setChannels([...copiedMessageChannels]);
    }

    // handle chat opened and mark the channel status as all messages seen and update the most recent message data in the chatlist card
    // const handleChatOpened = (data) => {

    // }

    const handleMobileChatsView = () => {
        setMobileChatsView(!mobileChatsView);
    }

    const handleChatSelect = (chatId: number) => {
        setSelectedChatId(chatId);
        setMobileChatsView(false);
        setSearchParams({ ['selectedChatId']: chatId.toString() })
    }
    const handleThis = (
    ) => {
        console.log(channels.length);
        console.log(totalChannelsAmount);
    }

    const moreChatsButton = false ?
        <SecondaryButton title={"Rohkem"} onClick={() => { handleThis() }}></SecondaryButton>
        : null;

    return (
        (channels.length > 0 || isCreateNew || loadingChannels) ?
            <div className={`w-full h-[90vh] lg:max-h-[80vh] flex lg:pt-[50px]`}>

                <Helmet>
                    <title>Rentic - Vestlused</title>
                    <meta name="description" content="Vestle teistega otse Renticu platformil ning sõlmi rendileping kiirelt ja lihtsalt." />
                    <meta name="keywords" content="rentic, vestlused, rendivestlus, rendileping, renditaotlus, rental request, renting chat" />
                    <meta property="og:title" content="Rentic - Vestlused" />
                    <meta property="og:description" content="Vestle teistega otse Renticu platformil ning sõlmi rendileping kiirelt ja lihtsalt." />
                    <meta property="og:image" content="/logo512.png" />
                    <meta property="og:url" content="https://rentic.ee/my-orders" />
                </Helmet>

                <div className="relative flex flex-col h-full lg:flex-row gap-3 lg:gap-10 flex-grow justify-center text-left">
                    {(window.innerWidth > 1024) ?
                        <div className={`${(isCreateNew && !channels.length) ? "hidden" : ""} basis-1/4 flex w-full gap-y-1 gap-3 lg:gap-3 items-start lg:items-stretch flex-shrink-0 flex-col lg:p-10 lg:w-[320px]`}>

                            {props.pageType === "rentals" ?
                                <h3>Minu rendid</h3>
                                :
                                <h3>Minu välja laenutatud</h3>
                            }

                            {loadingChannels ? Array.from({ length: 4 }, (_, index) => (
                                <ChatListCardSkeleton key={index} />
                            )) :

                                channels.map((data, index) => (
                                    <ChatListCard
                                        selectedChatId={selectedChatId}
                                        key={index}
                                        onClick={() => handleChatSelect(data.chat.id)}
                                        data={{
                                            rentalTitle: data.rental.product.title,
                                            name: data.chat.senderProfileName,
                                            profileImg: data.chat.senderProfilePicUrl!,
                                            lastMessage: data.chat.lastMessageMessage!,
                                            timeAgo: data.chat.lastMessageAtDate!,
                                            lastMessageUserId: data.chat.lastMessageUserId,
                                            userVerified: data.chat.senderVerified, // Optional field
                                            rentalIsActive: false,
                                            chatId: data.chat.id,
                                            lastMessageSeen: data.chat.lastMessageSeen!,
                                            newMessage: data.chat.newMessage
                                        }}
                                    />
                                ))}

                            {moreChatsButton}

                        </div> :

                        <div className={`${(mobileChatsView && !isCreateNew) ? "" : "hidden"} flex fixed pb-10 px-5 pt-[100px] top-0 h-full w-full gap-y-1 gap-3 lg:gap-3 overflow-auto items-start lg:items-stretch flex-shrink-0 flex-col lg:p-10 bg-white z-30`}>
                            {props.pageType === "rentals" ?
                                <h3>Minu rendid</h3>
                                :
                                <h3>Minu välja laenutatud</h3>
                            }

                            {loadingChannels && chatSelection != 0 ? Array.from({ length: 4 }, (_) => (
                                <ChatListCardSkeleton />
                            )) :

                                channels.map((data, index) => (

                                    <ChatListCard
                                        selectedChatId={selectedChatId}
                                        key={index}
                                        onClick={() => { handleChatSelect(data.chat.id) }}
                                        data={{
                                            rentalTitle: data.rental.product.title,
                                            name: data.chat.senderProfileName,
                                            profileImg: data.chat.senderProfilePicUrl!,
                                            lastMessage: data.chat.lastMessageMessage!,
                                            timeAgo: data.chat.lastMessageAtDate!,
                                            lastMessageUserId: data.chat.lastMessageUserId,
                                            userVerified: data.chat.senderVerified, // Optional field
                                            rentalIsActive: false,
                                            chatId: data.chat.id,
                                            lastMessageSeen: data.chat.lastMessageSeen!,
                                            newMessage: data.chat.newMessage
                                        }}

                                    />
                                ))}

                        </div>

                    }

                    <div className="lg:basis-3/4 w-full h-full">

                        <ChatTabContent isSelected={chatSelection === 0}>
                            {
                                (isCreateNew && data2?.productData) ?
                                    <ChatRequestView productData={data2.productData} startDate={data2.startDate}
                                                     endDate={data2.endDate} startTime={data2.startTime} endTime={data2.endTime} />
                                    :
                                    <>
                                        {

                                            (channels.length > 0 && selectedChatId) ?
                                                <ChatView chatId={selectedChatId} data={
                                                    channels.find(data =>
                                                        data.chat.id === selectedChatId)} key={selectedChatId}
                                                          setMobileChatsView={handleMobileChatsView} 
                                                          handleNewMessageInChat={(d) => handleCurrentChatNewMessage(d)}/>
                                                :
                                                <></>
                                        }
                                    </>
                            }
                        </ChatTabContent>
                        {/* <ChatTabContent isSelected={chatSelection === 1}>
                        Chat 1

                    </ChatTabContent>
                    <ChatTabContent isSelected={chatSelection === 2}>
                        Chat 2
                    </ChatTabContent> */}

                    </div>

                </div>
            </div>
            : <NoneUserRented text={"Sul pole veel ühtegi vestlust."} buttonLink="/" buttonText="Rendi midagi" icon={<AnnouncementIcon className="text-primary" style={{ height: "100px", width: "100px" }}></AnnouncementIcon>} />
    )
}